import config from '../package.json';
import { Env, Environment, Environments } from '@/types/environment';

const production: Environment = {
  cstBaseUrl: 'https://papi.vestiairecollective.com/v1/customer-support',
  portalUrl: 'https://backoffice.vestiairecollective.com',
  zendeskUrl: 'https://vestiairecollective.zendesk.com',
  timelineBaseUrl: 'https://papi.vestiairecollective.com/tiaggr/v3',
  webUrl: 'https://vestiairecollective.com',
  publicBaseUrl: 'https://apiv2.vestiairecollective.com',
  privateBaseURL: 'https://papi.vestiairecollective.com',
  idToken: 'id_token',
  bearerName: 'access_token',
  imagesBaseUrl: 'https://images.vestiairecollective.com',
  legacyBoUrl: 'https://bo.vestiairecollective.com/admin',
  productBoUri: '/admin.php?EZBO_page=modifproduit_mini&id=<pIdPlaceholder>&EZBO_close_auto_thickbox=1',
  logLevel: 'warn',
  datadog: {
    enabled: true,
    config: {
      applicationId: '665d8d4b-564a-4e80-9a32-18becfeb6466',
      clientToken: 'pubb2b4f2289c21e966524244a5c0a7fb5d',
      environment: 'production',
      name: config.name,
      version: config.version,
    },
  },
  tracking: {
    enabled: true,
    config: {
      appId: 'C360',
      platform: 'web',
      url: 'collector.vestiairecollective.com',
    },
  },
  itemShippingStatusWarehouseUpdateUrl: 'https://backoffice.vestiairecollective.com/warehouse',
  extraPayoutUrl: 'https://backoffice.vestiairecollective.com/extra-payout',
};

export const environments: Environments = {
  dev: {
    cstBaseUrl: 'https://papi.staging.vestiairecollective.com/v1/customer-support',
    portalUrl: 'http://localhost:3000',
    zendeskUrl: 'https://vestiairecollective1713858608.zendesk.com',
    timelineBaseUrl: 'https://papi.staging.vestiairecollective.com/tiaggr/v3',
    webUrl: 'https://staging.vestiairecollective.com',
    publicBaseUrl: 'https://apiv2.staging.vestiairecollective.com',
    privateBaseURL: 'https://papi.staging.vestiairecollective.com',
    idToken: 'id_token',
    bearerName: 'access_token',
    imagesBaseUrl: 'https://images.staging.vestiairecollective.com',
    legacyBoUrl: 'https://bo.stage.vestiairecollective.com/admin',
    productBoUri: '/admin.php?EZBO_page=modifproduit_mini&id=<pIdPlaceholder>&EZBO_close_auto_thickbox=1',
    logLevel: 'debug',
    datadog: {
      enabled: false,
      config: {
        applicationId: '665d8d4b-564a-4e80-9a32-18becfeb6466',
        clientToken: 'pubb2b4f2289c21e966524244a5c0a7fb5d',
        environment: 'development',
        name: config.name,
        version: config.version,
      },
    },
    tracking: {
      enabled: false,
      config: {
        appId: 'C360',
        platform: 'web',
        url: 'team-vctools-prod1.mini.snplow.net',
      },
    },
    itemShippingStatusWarehouseUpdateUrl: 'https://backoffice.staging.vestiairecollective.com/warehouse',
    extraPayoutUrl: 'https://backoffice.staging.vestiairecollective.com/extra-payout',
  },
  teod: {
    cstBaseUrl: 'https://papi.staging.vestiairecollective.com/v1/customer-support',
    portalUrl: 'https://backoffice.staging.vestiairecollective.com',
    zendeskUrl: 'https://vestiairecollective1713858608.zendesk.com',
    timelineBaseUrl: 'https://papi.staging.vestiairecollective.com/tiaggr/v3',
    webUrl: 'https://staging.vestiairecollective.com',
    publicBaseUrl: 'https://apiv2.staging.vestiairecollective.com',
    privateBaseURL: 'https://papi.staging.vestiairecollective.com',
    idToken: 'id_token',
    bearerName: 'access_token',
    imagesBaseUrl: 'https://images.staging.vestiairecollective.com',
    legacyBoUrl: 'https://bo.stage.vestiairecollective.com/admin',
    productBoUri: '/admin.php?EZBO_page=modifproduit_mini&id=<pIdPlaceholder>&EZBO_close_auto_thickbox=1',
    logLevel: 'debug',
    datadog: {
      enabled: true,
      config: {
        applicationId: '665d8d4b-564a-4e80-9a32-18becfeb6466',
        clientToken: 'pubb2b4f2289c21e966524244a5c0a7fb5d',
        environment: 'stage',
        name: config.name,
        version: config.version,
      },
    },
    tracking: {
      enabled: true,
      config: {
        appId: 'C360',
        platform: 'web',
        url: 'team-vctools-prod1.mini.snplow.net',
      },
    },
    itemShippingStatusWarehouseUpdateUrl: 'https://backoffice.staging.vestiairecollective.com/warehouse',
    extraPayoutUrl: 'https://backoffice.staging.vestiairecollective.com/extra-payout',
  },
  stage: {
    cstBaseUrl: 'https://papi.staging.vestiairecollective.com/v1/customer-support',
    portalUrl: 'https://backoffice.staging.vestiairecollective.com',
    zendeskUrl: 'https://vestiairecollective1713858608.zendesk.com',
    timelineBaseUrl: 'https://papi.staging.vestiairecollective.com/tiaggr/v3',
    webUrl: 'https://staging.vestiairecollective.com',
    publicBaseUrl: 'https://apiv2.staging.vestiairecollective.com',
    privateBaseURL: 'https://papi.staging.vestiairecollective.com',
    idToken: 'id_token',
    bearerName: 'access_token',
    imagesBaseUrl: 'https://images.staging.vestiairecollective.com',
    legacyBoUrl: 'https://bo.stage.vestiairecollective.com/admin',
    productBoUri: '/admin.php?EZBO_page=modifproduit_mini&id=<pIdPlaceholder>&EZBO_close_auto_thickbox=1',
    logLevel: 'debug',
    datadog: {
      enabled: true,
      config: {
        applicationId: '665d8d4b-564a-4e80-9a32-18becfeb6466',
        clientToken: 'pubb2b4f2289c21e966524244a5c0a7fb5d',
        environment: 'stage',
        name: config.name,
        version: config.version,
      },
    },
    tracking: {
      enabled: true,
      config: {
        appId: 'C360',
        platform: 'web',
        url: 'team-vctools-prod1.mini.snplow.net',
      },
    },
    itemShippingStatusWarehouseUpdateUrl: 'https://backoffice.staging.vestiairecollective.com/warehouse',
    extraPayoutUrl: 'https://backoffice.staging.vestiairecollective.com/extra-payout',
  },
  prod: production,
  production, // Some how Dashboard use production instead of prod
};

/**
 * True only when running on a local dev machine.
 *
 * Its sole caller is `resolveEnv()`, to select the `dev` configuration. It no
 * longer gates a login path: the PKCE branch it used to guard in `main.tsx` is
 * gone and every environment, local included, now delegates auth to the portal.
 */
export function isLocalDev(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }
  const host = window.location.hostname;
  return host === 'localhost' || host === '127.0.0.1';
}

/**
 * Resolve the runtime environment from the hostname.
 *
 * Standalone c360 no longer receives `env` from the dashboard as a prop, so it
 * is derived from where the app is served:
 *   - c360.backoffice.vestiairecollective.com          -> production
 *   - c360.backoffice.staging.vestiairecollective.com  -> stage
 *   - *.pages.dev preview deployments                  -> stage (staging APIs)
 *   - localhost / 127.0.0.1                            -> dev
 *
 * TODO(CS-0): confirm the exact production/staging hostnames with infra once the
 * custom domains are mapped to the `backoffice-360-module` Cloudflare Pages
 * project.
 */
export function resolveEnv(): Env {
  if (isLocalDev()) {
    return 'dev';
  }
  const host = typeof window !== 'undefined' ? window.location.hostname : '';
  if (host === 'c360.backoffice.vestiairecollective.com') {
    return 'production';
  }
  // Staging custom domain and Cloudflare Pages preview deployments both use the
  // staging API configuration.
  return 'stage';
}
